import { Button, ButtonProps } from '@uk-source-web/button';
import { SmallButton } from '@uk-source-web/small-button';
import { useBreakpoints } from '@uk-source-web/match-media';

import { BasketNavigationWrapper } from './BasketNavigation.styles';
import { BasketNavigationButtons } from '../BasketSummary.types';
import { useLocation } from '@reach/router';

type ButtonTypes = 'summary' | 'secondary';

const BasketNavigation = ({ summaryButton, secondaryButton }: BasketNavigationButtons) => {
  const { sm, mdAndAbove } = useBreakpoints();
  const location = useLocation();

  const getDefaultText = (type: ButtonTypes) => {
    if (type === 'summary') {
      return 'Continue';
    } else if (type === 'secondary') {
      return 'Next option';
    }
    return '';
  };

  const handleButtonClick = (
    originalOnClick: ((event?: any) => void) | undefined,
    buttonText: string,
    href: string | undefined,
    e?: React.MouseEvent
  ) => {
    // Track analytics
    window.utag?.link({
      event_name: 'Go to Basket',
      event_category: location.pathname,
      event_label: 'Go to Basket',
      event_action: 'Button Click',
      component_type: 'Button',
    });

    // Call original onClick 
    if (originalOnClick) {
      originalOnClick(e);
    }

    
    if (href && !originalOnClick && e) {
      e.preventDefault();
      setTimeout(() => {
        window.location.href = href;
      }, 500);
    }
  };

  const getButtonsProps = (
    btn: BasketNavigationButtons['summaryButton'] | BasketNavigationButtons['secondaryButton'],
    type: ButtonTypes
  ): ButtonProps => {
    const buttonText = btn?.text ? btn.text : getDefaultText(type);
    
    return {
      customRouterProps: btn?.customRouterProps,
      href: btn?.onClick ? btn.href : undefined, // Remove href if there's onClick to avoid conflict
      onClick: (e?: React.MouseEvent) => handleButtonClick(btn?.onClick, buttonText, btn?.href, e),
      text: buttonText,
      state: btn?.state ? 'disabled' : undefined,
      loading: btn?.loading,
    };
  };

  const summaryBtnProps = getButtonsProps(summaryButton, 'summary');
  const secondaryBtnProps = secondaryButton && getButtonsProps(secondaryButton, 'secondary');

  return (
    <BasketNavigationWrapper>
      {sm ? <SmallButton {...summaryBtnProps} /> : <Button {...summaryBtnProps} width={mdAndAbove ? 'auto' : 'full'} />}
      {secondaryButton &&
        secondaryBtnProps &&
        (sm ? (
          <SmallButton {...secondaryBtnProps} appearance="secondary" />
        ) : (
          <Button {...secondaryBtnProps} width={mdAndAbove ? 'auto' : 'full'} appearance="secondary" />
        ))}
    </BasketNavigationWrapper>
  );
};

export default BasketNavigation;
